import classNames from 'classnames';
import { Fragment } from 'react';
import { Button, Dialog, DialogProps } from 'tdesign-react';

import styles from './index.module.less';

interface NovaDialogProps {
  dialogConfig: DialogProps;
  children?: React.ReactNode;
  confirmBtnLoading?: boolean;
  confirmBtnDisabled?: boolean;
  hiddenFooter?: boolean;
  isTransParent?: boolean
}

/**
 * 弹窗组件
 */
const NovaDialog: React.FC<NovaDialogProps> = (props) => {
  const {
    dialogConfig,
    confirmBtnLoading,
    confirmBtnDisabled,
    hiddenFooter,
    isTransParent,
  } = props;

  const handleEnsure = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    dialogConfig?.onConfirm?.(e as unknown as {
      e:
      | React.MouseEvent<HTMLButtonElement>
      | React.KeyboardEvent<HTMLDivElement>;
    });
  };

  return (
    <Fragment>
      <Dialog
        className={
          classNames(
            { [styles.novaDialogNoFooter]: hiddenFooter && !isTransParent },
            { [styles.novaDialog]: !hiddenFooter && !isTransParent },
            { [styles.novaDialogTransParent]: isTransParent },
            dialogConfig.className,
          )
        }
        confirmBtn={
          <Button
            loading={confirmBtnLoading}
            disabled={confirmBtnDisabled}
            onClick={e => handleEnsure(e)}
          >
            确定
          </Button>
        }
        {...dialogConfig}
      >
        {props.children}
      </Dialog>
    </Fragment>
  );
};

export default NovaDialog;
